/* eslint-disable react/jsx-filename-extension */
/* eslint-disable global-require */
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

function Pending() {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: require('./Lottie_Pending.json'),
    });
  }, []);

  return (
    <div className="w-h-200 m-auto" ref={container} />
  );
}

export default Pending;
